import {Injectable} from '@angular/core';
import {LoaderSpinner} from '@models/loader-spiner.interface';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderSpinerService {

  private readonly loaderSubject = new BehaviorSubject<LoaderSpinner>({showSpinner: false});
  loaderSpiner$ = this.loaderSubject.asObservable();


  show(message?: string) {
    this.loaderSubject.next({showSpinner: true, message: message});
  }

  hide() {
    this.loaderSubject.next({showSpinner: false});
  }
}
